import { render, staticRenderFns } from "./HandwareProductsPage.vue?vue&type=template&id=e3eb4222"
import script from "./HandwareProductsPage.vue?vue&type=script&lang=js"
export * from "./HandwareProductsPage.vue?vue&type=script&lang=js"
import style0 from "./HandwareProductsPage.vue?vue&type=style&index=0&id=e3eb4222&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports